package one.healthium.insights.ui.insights.models

import one.healthium.loco.LString

internal data class HeaderUiModel(
    val id: String,
    val title: LString,
)
